module.exports = __webpack_public_path__ + "media/images/social-share-button/douban-176bcde981e6740c29b43f6fcea7616c.svg";